
export default {
  agentType: '0:普通代理商&1:代理商&2:服务商&3:联合创始人&4:创业代理&5:合伙人',
  businessArea: 'banner:轮播图&kingkong:金刚区&recommended:精选推荐&recommendedThird:大牌推荐&recommendedList:综合推荐'
};
